import React, { useState, useEffect } from "react";
import { useQuery, useMutation } from "react-query";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Fuse from "fuse.js";

import { GET, POST, PUT } from "../../api/requests";
import Button from "../../components/Button";

export default function Lambdas() {
  const navigate = useNavigate();

  const [lambdas, setLambdas] = useState([]);
  const [activeTab, setActiveTab] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const { data: fetchedLambdas } = useQuery(
    ["credentials"],
    async () => {
      const response = await GET(`/lambdas`);
      return response;
    },
    {
      onSuccess: (data) => {
        console.log({ data });
        if (data) setLambdas(data);
      },
    }
  );

  const groupLambdas = (lambdas) => {
    const groups = {};
    lambdas.forEach((lambda) => {
      const [group] = lambda.displayTitle.toLowerCase().split("_");
      if (group) {
        if (!groups[group]) groups[group] = [];
        groups[group].push(lambda);
      } else {
        if (!groups["Other"]) groups["Other"] = [];
        groups["Other"].push(lambda);
      }
    });
    return groups;
  };

  const groupedLambdas = groupLambdas(lambdas);
  const tabs = Object.keys(groupedLambdas);

  useEffect(() => {
    if (tabs.length > 0 && !activeTab) {
      setActiveTab(tabs[0]);
    }
  }, [tabs, activeTab]);

  const filteredLambdas = searchTerm
    ? lambdas.filter((lambda) =>
        lambda.displayTitle.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : groupedLambdas[activeTab] || [];

  return (
    <>
      <div className="space-y-2">
        <div className="mx-auto pt-16 max-w-5xl px-4 sm:px-12 lg:px-12 mb-6">
          <div className="flex sm:flex-row items-center space-y-4 sm:space-y-0">
            <h1 className="font-semibold text-lg px-2 text-slate-700 w-1/4">
              Lambda manager
            </h1>
            <div className="w-3/4 flex items-center space-x-2">
              <input
                type="text"
                placeholder="Search lambdas..."
                className="w-full px-4 py-2 rounded-md border border-gray-300 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button
                onClick={() => navigate("/lambdas/manage")}
                className="text-xs text-white font-medium bg-slate-800 rounded-md px-3 py-2 whitespace-nowrap"
              >
                New
              </button>
            </div>
          </div>
        </div>

        <div className="mx-auto space-y-2 max-w-5xl px-4 sm:px-12 lg:px-12">
          <div className="flex">
            <div className="w-1/4 pr-4">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`block w-full text-xs rounded-md text-left px-4 py-2 ${
                    activeTab === tab
                      ? "bg-blue-600 text-white"
                      : "hover:bg-gray-100"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1).toLowerCase()}
                </button>
              ))}
            </div>

            <div className="w-3/4">
              {filteredLambdas.map((lambda) => (
                <div
                  key={lambda.id}
                  id={`lambda:${lambda.id}`}
                  className="rounded-xl mx-auto shadow-lg shadow-gray-50 shadow-opacity-20 border border-gray-200 bg-white pt-3 mb-4"
                >
                  <div className="justify-between flex items-center pl-3 pr-3 space-x-2 text-sm text-gray-800">
                    <div className="flex items-center w-full justify-between">
                      <div className="flex items-center w-full font-semibold text-slate-800 text-xs">
                        {lambda.displayTitle}
                      </div>
                      <div className="flex items-center"></div>
                    </div>
                    <div
                      style={{ fontSize: 10 }}
                      className="ml-2 font-normal w-1/3 text-gray-500 flex items-center justify-end"
                    >
                      <div style={{ fontSize: 10 }} className="text-gray-400">
                        Created at{" "}
                        {new Date(lambda.created_at).toLocaleTimeString()}
                      </div>
                    </div>
                  </div>

                  <div className="snippets mt-3 border-t border-gray-200 overflow-hidden divide-gray-100 divide-y">
                    <div className="flex items-center px-4 py-3 relative">
                      <div className="text-xs text-gray-500 flex-1 w-full items-center overflow-x-auto ">
                        <div className="flex items-center space-x-2 flex-nowrap"></div>
                        <div className="flex items-center">
                          <button
                            onClick={() =>
                              navigator.clipboard.writeText(lambda.functionUrl)
                            }
                            className="mr-2 text-gray-500 hover:text-gray-700"
                            title="Copy to clipboard"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                              />
                            </svg>
                          </button>
                          <p>{lambda.functionUrl}</p>
                        </div>
                      </div>

                      <div className="flex items-center ml-3">
                        <button
                          onClick={() =>
                            navigate(`/lambdas/${lambda.id}/manage`)
                          }
                          style={{
                            backgroundColor: "#C2FB20",
                            color: "#0F172A",
                          }}
                          className=" py-1.5 flex hover:bg-opacity-70 items-center space-x-1.5 font-medium text-xs px-2.5 rounded-md"
                        >
                          <p>Edit</p>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
